import { useEffect, useRef } from 'react';
import { usePageShortcuts } from '../context/PageShortcutContext';

/**
 * Hook for pages to register their shortcut callbacks.
 * Uses a ref so the Layout always sees the latest callbacks.
 * 
 * @param {Object} callbacks - { onNewEntry, onPrevTab, onNextTab }
 */
export const usePageCallbacks = (callbacks) => {
  const { registerCallbacks, clearCallbacks } = usePageShortcuts();
  const cbRef = useRef(callbacks);
  cbRef.current = callbacks;

  useEffect(() => {
    registerCallbacks({
      onNewEntry: (...args) => cbRef.current.onNewEntry?.(...args),
      onPrevTab: (...args) => cbRef.current.onPrevTab?.(...args),
      onNextTab: (...args) => cbRef.current.onNextTab?.(...args),
      onDateQuick: (...args) => cbRef.current.onDateQuick?.(...args),
      onDateCustom: (...args) => cbRef.current.onDateCustom?.(...args),
      onClearAction: (...args) => cbRef.current.onClearAction?.(...args),
    });
    return () => clearCallbacks();
  }, [registerCallbacks, clearCallbacks]);
};
